import { useCurrentUserId, useCurrentWorkspaces } from 'src/store';

export const useUserDefaultWorkspaceId = () => {
  const currentWorkspaces = useCurrentWorkspaces();
  const currentUserId = useCurrentUserId();

  return currentWorkspaces.find((w) => (w.defaultForUserIds || []).includes(String(currentUserId)))
    ?.id;
};
